import {Box, Chip} from '@mui/material';

interface FilterChipProps {
  filter: {label: string; value: string};
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onRemove: (value: any) => void;
}

const FilterChip: React.FC<FilterChipProps> = ({filter, onRemove}) => {
  return (
    <Box>
      <Chip
        label={filter.label}
        onDelete={() => onRemove(filter.value)}
        color="secondary"
        sx={{cursor: 'default'}}
      />
    </Box>
  );
};

export default FilterChip;
